import {
    FilterData,
    FilterBlockTypesEnum,
    ContentData,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const filterData: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Select,
            multiple: true,
            name: "languages",
            options: [
                {
                    value: "en"
                },
                {
                    value: "de"
                },
                {
                    value: "it"
                },
                {
                    value: "fr"
                }
            ],
        },
        {
            type: FilterBlockTypesEnum.Checkbox,
            filterItems: [
                {
                    name: "equipment-material",
                    value: "equipment-material",
                },
            ],
        },
    ],
};

const contentData: ContentData = {
    totalCount: 33,
    filteredCount: 33,
    schema: {
        category: {
            order: [1001, 1002, 1003, 1004],
        },
    },
    items: [
        {
            equipmentNumber: "L4630M0357",
            name: "Spare Parts Catalog PFO 3D-3",
            id: 1153222,
            typeId: 2,
            languages: ["de"],
            date: "2021-11-01",
            path: "https://my.trumpf.com/api/download?id=1153223",
            size: 3928555,
            category: 1004,
        },
        {
            equipmentNumber: "L4630M0356",
            name: "Operation Manual PFO 3D-2",
            id: 1142603,
            typeId: 1,
            languages: ["en"],
            date: "2017-06-01",
            size: 4725399,
            category: 1001,
        },
        {
            equipmentNumber: "L4630M0356",
            name: "Operation Manual PFO 3D-2",
            id: 1142797,
            typeId: 1,
            languages: ["en"],
            date: "2019-07-01",
            path: "https://my.trumpf.com/api/download?id=1142797",
            size: 5916769,
            category: 1001,
        },
        {
            equipmentNumber: "L4630M0356",
            name: "Spare Parts Catalog PFO 3D-2, PFO 3D-2 PO, I-PFO",
            id: 1153222,
            typeId: 2,
            languages: ["de", "fr", "en"],
            date: "2021-11-01",
            path: "https://my.trumpf.com/api/download?id=1153222",
            size: 3928555,
            category: 1004,
        },
    ],
};

const writeToFile = (object: any, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(filterData, "mymachine-downloads-filter");
writeToFile(contentData, "mymachine-downloads-content");
